export const CHECKBOX_STYLES = {
  root: "peer h-4 w-4 shrink-0 rounded-[4px] border border-ticketon-light-border focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50  data-[state=checked]:border-none  data-[state=checked]:bg-ticketon-lighter-blue data-[state=checked]:text-primary-foreground",
  indicator: "flex items-center justify-center text-current",
  label:
    "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer",
  container: "flex items-center space-x-2",
} as const;
